import React from "react";
import style from "styled-components";

const StyledPortletWrapper = style.div`
`;

const PortletWrapper = ({ children }) => (
    <StyledPortletWrapper>{children}</StyledPortletWrapper>
);

export default PortletWrapper;



// WEBPACK FOOTER //
// ./components/misc/PortletWrapper.jsx